import { graphql } from "react-relay";

export const UpdatePolicyCollectionItemMutation = graphql`
  mutation UpdatePolicyCollectionItemMutation(
    $input: PolicyCollectionItemInput!
  ) {
    updatePolicyCollectionItem(input: $input) {
      collection {
        id
      }
    }
  }
`;
